import { useState } from 'react';
import { Story } from '../../schema';

interface UseEditStoryModalReturn {
  isOpen: boolean;
  editingStory: Story | null;
  openForEdit: (story: Story) => void;
  openForCreate: (story: Story) => void;
  close: () => void;
}

/**
 * Hook to manage story editing modal state.
 * Platform-agnostic: Pure state management, works in React Native.
 *
 * @returns Modal state and control functions
 */
export const useEditStoryModal = (): UseEditStoryModalReturn => {
  const [isOpen, setIsOpen] = useState(false);
  const [editingStory, setEditingStory] = useState<Story | null>(null);

  const openForEdit = (story: Story) => {
    setEditingStory(story);
    setIsOpen(true);
  };

  const openForCreate = (story: Story) => {
    setEditingStory(story);
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
    setEditingStory(null);
  };

  return {
    isOpen,
    editingStory,
    openForEdit,
    openForCreate,
    close,
  };
};
